<template>
  <div>
    <v-bottom-sheet
      v-model="computedValue"
      :hide-overlay="hideOverlay"
      :persistent="persistent"
    >
      <v-sheet class="bg-white pa-4 sheet-container">
        <header class="d-flex justify-space-between align-center">
          <h2>
            <slot name="title"></slot>
          </h2>
          <v-btn
            fab
            x-small
            elevation="0"
            @click="close"
          >
            <Icon
              :width="20"
              :color="'rgba(0,0,0,.54)'"
              :icon="'close'"
            />
          </v-btn>
        </header>
        <slot name="body">
          <p>This is the body of the bottom sheet.</p>
        </slot>
        <slot name="footer"></slot>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'BottomSheet',
  components: {
    Icon: () => import('@/components/Icon.vue')
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: true
    },
    hideOverlay: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    close() {
      this.computedValue = false;
    }
  },
}
</script>

<style>
h2 {
  font-size: 18px;
  margin: 0;
}

.v-bottom-sheet > div {
  -webkit-border-top-left-radius: 20px !important;
  -webkit-border-top-right-radius: 20px !important;;
  -moz-border-radius-topleft: 20px !important;
  -moz-border-radius-topright: 20px !important;
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
}

.v-bottom-sheet {
  -webkit-border-top-left-radius: 20px !important;
  -webkit-border-top-right-radius: 20px !important;;
  -moz-border-radius-topleft: 20px !important;
  -moz-border-radius-topright: 20px !important;
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
}
</style>